<template>
  <section class="home-banner">
    <div class="container">
      <blockquote>
        <span class="cs-textstyle-page-title">
          CTO Circle is a global network of CTOs and senior tech leaders who
          help each other succeed.
        </span>
        <cite>
          <cs-button
            href="https://csuitecircle.typeform.com/to/fEytYh02"
            variant="primary"
            fill="solid"
            size="medium"
            target="_blank"
            :style="{
              '--cs-button-color': '#ffffff',
              '--cs-button-text-color': '#007ea3'
            }"
            >Request an Invite</cs-button
          >
        </cite>
      </blockquote>
    </div>
    <div class="stats">
      <div class="container">
        <div class="row">
          <div class="col-md-4 mt-4">
            <h4 v-if="members && members.aggregate">
              {{ members.aggregate.count | formatNumber }}
            </h4>
            <h5>Members</h5>
          </div>
          <div class="col-md-4 mt-4">
            <h4 v-if="cities && cities.aggregate">
              {{ cities.aggregate.count | formatNumber }}
            </h4>
            <h5>Cities</h5>
          </div>
          <div class="col-md-4 mt-4">
            <h4 v-if="events && events.aggregate">
              {{ events.aggregate.count | formatNumber }}
            </h4>
            <h5>Upcoming Events</h5>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  props: {
    members: {
      type: Object,
      default() {
        return {};
      },
      required: true
    },
    countries: {
      type: Object,
      default() {
        return {};
      },
      required: true
    },
    cities: {
      type: Object,
      default() {
        return {};
      },
      required: true
    },
    events: {
      type: Object,
      default() {
        return {};
      },
      required: true
    }
  },

  data() {
    return {};
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
.home-banner {
  position: relative;
  background-color: #000112;
  color: #ffffff;
  background-image: url('~@/assets/img/home_banner.png');
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 143px 0 0;
  text-align: center;
  z-index: 1;

  @include media-breakpoint-up(md) {
    background-attachment: fixed;
    padding: 175px 0 0;
  }

  &:after {
    content: '';
    position: absolute;
    background-color: rgba(0, 1, 18, 0.6);
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: -1;
  }

  blockquote {
    font-size: 22px;
    font-weight: 300;
    line-height: 33px;
    max-width: 717px;
    margin: 0 auto;

    @include media-breakpoint-up(md) {
      font-size: 30px;
      line-height: 40px;
    }

    cite {
      display: block;
      margin-top: 30px;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
      margin-bottom: 87px;

      @include media-breakpoint-up(md) {
        font-size: 18px;
        line-height: 28px;
        margin-bottom: 150px;
      }

      p {
        margin-bottom: 3px;
      }
      strong {
        font-weight: 900;
      }
    }
  }

  svg {
    fill: $primary;
    margin-bottom: 20px;
  }

  .stats {
    background-color: var(--cs-primary-base);
    padding: 31px 0 41px;
    background-size: contain;
    background-position: bottom right;
    background-image: url('~@/assets/img/About-Decor-Head-Mobile@2x.png');
    background-repeat: no-repeat;
    background-clip: padding-box;

    @include media-breakpoint-up(md) {
      padding: 45px 0 35px;
      background-size: cover;
      background-image: url('~@/assets/img/Home_stats_Decor_Head.png');
    }

    h4 {
      font-size: 44px;
      font-weight: 700;
      line-height: 35px;
      @include media-breakpoint-up(md) {
        font-size: 50px;
      }
    }

    h5 {
      font-size: 25px;
      font-weight: 700;
      @include media-breakpoint-up(md) {
        font-size: 27px;
      }
    }
  }
}
</style>
